import React, { useState, useEffect, useRef } from 'react';
import clsx from 'clsx';
import styles from './UIGamePause.module.scss';
import { T } from '@colonist/ui';
import { UIGameButton } from '../../common/UIGameButton/index.ts';
import { Timer } from '../../common/Timer/Timer.tsx';
import { useRequestResume } from '../../hooks/usePause.ts';
import { useGameStore } from '../../store/GameStoreContext.ts';
export const UIGamePause = ()=>{
    const isPaused = useGameStore((state)=>state.gamePause.isPaused);
    const remainingPauseTimeMS = useGameStore((state)=>state.gamePause.remainingPauseTimeMS);
    const isMyColorSpectator = useGameStore((state)=>state.isMyColorSpectator);
    const isOpenSettings = useGameStore((state)=>state.gameUserSettings.isOpenSettings);
    const requestResume = useRequestResume();
    const sendMobileResumedGameAnalytics = useGameStore((state)=>state.gameAnalytics.sendMobileResumedGameAnalytics);
    const onResumeClick = ()=>{
        sendMobileResumedGameAnalytics();
        requestResume();
    };
    const [countdown, setCountdown] = useState(undefined);
    const startTimeRef = useRef(undefined);
    useEffect(()=>{
        if (!isPaused) {
            setCountdown(undefined);
            startTimeRef.current = undefined;
            return;
        }
        if (remainingPauseTimeMS !== undefined) {
            startTimeRef.current = Date.now();
            setCountdown(Math.floor(remainingPauseTimeMS / 1000));
        }
        const timer = setInterval(()=>{
            if (startTimeRef.current === undefined || remainingPauseTimeMS === undefined) return;
            const elapsed = Date.now() - startTimeRef.current;
            const remaining = Math.max(0, Math.floor((remainingPauseTimeMS - elapsed) / 1000));
            setCountdown(remaining);
            if (remaining <= 0) {
                clearInterval(timer);
            }
        }, 100) // Update more frequently for smoother countdown
        ;
        return ()=>clearInterval(timer);
    }, [
        isPaused,
        remainingPauseTimeMS
    ]);
    if (!isPaused) return null;
    return /*#__PURE__*/ React.createElement("div", {
        className: clsx(styles.container, {
            [styles.hideBackground]: isOpenSettings
        })
    }, /*#__PURE__*/ React.createElement("div", {
        className: styles.title
    }, /*#__PURE__*/ React.createElement(T, {
        id: "strings:game.pause.paused"
    })), /*#__PURE__*/ React.createElement("div", {
        className: styles.timer
    }, /*#__PURE__*/ React.createElement(Timer, {
        timeLeftInSeconds: countdown
    })), !isMyColorSpectator && /*#__PURE__*/ React.createElement("div", {
        className: styles.buttons
    }, /*#__PURE__*/ React.createElement(UIGameButton, {
        className: styles.resumeButton,
        onClick: onResumeClick
    }, /*#__PURE__*/ React.createElement(T, {
        id: "strings:game.pause.resume"
    }))));
};
